import FormStatusReducer from './FormStatusReducer'
import FormDataReducer from './FormDataReducer'
import AdminReducer from './AdminReducer'
import LoginReducer from './LoginReducer'

import { combineReducers } from 'redux';

const rootReducer = combineReducers({
    FormStatusReducer,
    FormDataReducer,
    AdminReducer,
    LoginReducer,
    
})

export default rootReducer;